const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const recaptchaManager = require('od-modules/users/recaptcha');
const {processTemplateData, getEventType} = require('../../utils');
const {eventConstants} = require('./../../constants');
const {specialCharacters} = require('od-modules/utils/input_pattern_utils');

const nameRegex = `^[a-zA-Z ${specialCharacters}]{2,}$`;

module.exports = withRenderedMain(BaseView.extend({
    initialize() {
        this.bindEvents();
        this.render();
    },

    bindEvents() {
        this.listenTo(this.model, 'change:openRegisterForm', this.onToggleRegisterForm);
        this.listenTo(this.model, 'change:submitForm', this.onRegisterAction);
        this.listenTo(this.model, 'change:userType', this.render);
        this.listenTo(this.model, 'change:bookingDetailDTO', this.onChangedBookingDetail);
    },

    selectors: {
        formContainer: '.register_form_container',
        primeTravellersContainer: '.prime_travellers',
        primeEmailContainer: '.prime_email',
        primeBtnContainer: '.prime_btn',
        pwdInput: '.password_input',
        nameInput: '.name_input',
        nameError: '.name_error',
        emailInput: '.email_input',
        emailError: '.email_error',
        lastNameInput: '.last_name_input',
        lastNameError: '.last_name_error',
        pwdError: '.pwd_error',
        pwdContainer: '.pwd_container',
        nameContainer: '.name_container',
        lastNameContainer: '.last_name_container',
        emailContainer: '.email_container',
        registerBtn: '.register_prime',
        closeRegisterBtn: '.close_register_form',
        eyeIconPwd: '.eye_icon_pwd',
        conditionsLink: '.conditions_link',
        privacyLink: '.privacy_link',
        registerLoading: '.register_loading',
        prismaInput: '.prisma_input_group',
    },

    events: {
        'tap .register_prime': 'onRegisterAction',
        'tap .close_register_form': 'onCloseRegisterForm',
        'tap .eye_icon_pwd': 'onToggleEyeIcon',
        'tap .conditions_link': 'onConditionsLink',
        'tap .privacy_link': 'onPrivacyLink',
        'focus .prisma_input_group': 'onFocusInput',
        'blur .prisma_input_group': 'onBlurInput',
    },

    _getEventType() {
        return getEventType(this.model.isRegistered());
    },

    onConditionsLink() {
        this.model.set('eventType', this._getEventType());
        this.model.trackEvent('terms');
    },

    onPrivacyLink() {
        this.model.set('eventType', this._getEventType());
        this.model.trackEvent('policy');
    },

    onToggleEyeIcon() {
        this.$el.find(this.selectors.eyeIconPwd).toggleClass('odf-hidden');
        if (this.$el.find(this.selectors.pwdInput).prop('type') === 'password') {
            this.$el.find(this.selectors.pwdInput).prop('type', 'text');
        } else {
            this.$el.find(this.selectors.pwdInput).prop('type', 'password');
        }
    },

    onCloseRegisterForm() {
        let eventType = this._getEventType();
        this.model.set({
            'eventType': eventType,
            'openRegisterForm': false,
        });
        this.model.trackEvent('back');
        eventType = 'start';
        this.model.set('eventType', eventType);
    },

    onToggleRegisterForm() {
        Odigeo.Utils.scrollToElement(this.selectors.formContainer);
        this._cleanErrors();
    },

    onFocusInput: function(e) {
        $(e.target).closest(this.selectors.prismaInput).addClass('focused');
    },

    onBlurInput: function(e) {
        $(e.target).closest(this.selectors.prismaInput).removeClass('focused');
    },

    onRegisterAction() {
        this.model.set({
            submitForm: false,
            register: true,
            eventType: 'register',
        }, {silent: true});
        if (this.model.isBasicFreeAccount()) {
            if (this._checkInputsValidity()) {
                this.model.trackEvent('register');
                return this.registerWithoutPassword();
            }

            return Odigeo.Utils.scrollToElement(this.selectors.formContainer);
        }
        if (!this.model.isRegistered() && !this._checkValidity()) {
            Odigeo.Utils.scrollToElement(this.selectors.formContainer);
        } else {
            this.renderRegisterBtn(true);
            this.register();
        }
    },

    registerWithoutPassword() {
        this.renderRecaptcha();
        recaptchaManager.gRecaptchaExecute(this.model.get('recaptchaWidgetID'));
    },

    register() {
        this.renderRecaptcha();
        this.model.set('eventType', this._getEventType());
        if (this.model.isRegistered()) {
            this.model.trackEvent(this._getEventType());
            this.openLoginForm();
        } else {
            if (this._checkValidity()) {
                this._cleanErrors();
                this.model.trackEvent(this._getEventType());
                recaptchaManager.gRecaptchaExecute(this.model.get('recaptchaWidgetID'));
            } else {
                Odigeo.Utils.scrollToElement(this.selectors.formContainer);
            }
        }
    },

    openLoginForm() {
        Odigeo.trigger(`${this.id}:openLoginForm`);
        if (this.model.isMobile()) {
            this.model.trackPage(eventConstants.login);
        }
        this.renderRegisterBtn(false);
    },

    onChangedBookingDetail() {
        this.triggerIsUserRegistered();
    },

    triggerIsUserRegistered() {
        Odigeo.trigger(`${this.id}:isUserRegistered`, Odigeo._.get(this.model.get('bookingDetailDTO'), 'buyer.mail') || '');
    },

    _cleanErrors() {
        this._togglePwdError(false, '');
        this._toggleNameError(false, '');
        this._toggleLastNameError(false, '');
        this._toggleEmailError(false, '');
    },

    renderRecaptcha() {
        const callBackFunction = this.model.isBasicFreeAccount() ? this.recaptchaNoPwdCallback : this.recaptchaCallback;
        if (recaptchaManager.isGRecaptchaLoaded && !this.model.get('recaptchaRendered')) {
            const siteKey = this.model.get('siteKey');
            this.model.set('recaptchaWidgetID', recaptchaManager.gRecaptchaRender('g_recaptcha_postbooking_register',
                Odigeo._.bind(callBackFunction, this), siteKey));
            this.model.set('recaptchaRendered', true);
        }
    },

    recaptchaNoPwdCallback() {
        this.model.createBasicFreeAccount(recaptchaManager.gRecaptchaGetResponse(this.model.get('recaptchaWidgetID')));
    },

    recaptchaCallback() {
        const recaptchaResponse = recaptchaManager.gRecaptchaGetResponse(this.model.get('recaptchaWidgetID'));
        const email = Odigeo._.get(this.model.get('bookingDetailDTO'), 'buyer.mail') || '';
        const password = this.$el.find(this.selectors.pwdInput).val();
        Odigeo.trigger(`${this.id}:registerUser`, {
            email,
            password,
            recaptchaResponse,
            acceptsNewsletter: false,
        });
    },

    _checkInputsValues(inputs) {
        let flag = true;
        if (!Odigeo.Utils.isValidEmail(inputs.email)) {
            this._toggleEmailError(true, this.keys.signUp.holderEmailError);
            flag = false;
            const error = `email_${inputs.email ? 'invalid_' : 'missing_'}submit`;
            this.model.trackEvent('pwdError', this.model.isRegistered(), error);
        }
        if (!inputs.name.match(nameRegex)) {
            this._toggleNameError(true, this.keys.signUp.holderNameError);
            flag = false;
            const error = `name_${inputs.name ? 'invalid_' : 'missing_'}submit`;
            this.model.trackEvent('pwdError', this.model.isRegistered(), error);
        }
        if (!inputs.lastName.match(nameRegex)) {
            this._toggleLastNameError(true, this.keys.signUp.holderLastNameError);
            flag = false;
            const error = `lastname_${inputs.lastName ? 'invalid_' : 'missing_'}submit`;
            this.model.trackEvent('pwdError', this.model.isRegistered(), error);
        }
        return flag;
    },

    _checkInputsValidity() {
        this._cleanErrors();
        const name = this.$el.find(this.selectors.nameInput).val() || '';
        const lastName = this.$el.find(this.selectors.lastNameInput).val() || '';
        const email = this.$el.find(this.selectors.emailInput).val() || '';
        if (!this._checkInputsValues({name, lastName, email})) {
            this.model.trackEvent('error');
            return false;
        }
        this.model.set({
            'name': name,
            'lastName': lastName,
            'email': email,
        });
        return true;
    },

    _toggleGenericError(containerSelector, errorSelector, isError, errorMsg) {
        const $container = this.$el.find(containerSelector);
        const $error = this.$el.find(errorSelector);
        if ($container && $error) {
            return this._toggleGenericErrorMessage($container, $error, isError, errorMsg);
        }
    },

    _togglePwdError(isError, errorMsg) {
        return this._toggleGenericError(this.selectors.pwdContainer, this.selectors.pwdError, isError, errorMsg);
    },

    _toggleNameError(isError, errorMsg) {
        return this._toggleGenericError(this.selectors.nameContainer, this.selectors.nameError, isError, errorMsg);
    },

    _toggleLastNameError(isError, errorMsg) {
        return this._toggleGenericError(this.selectors.lastNameContainer, this.selectors.lastNameError, isError, errorMsg);
    },

    _toggleEmailError(isError, errorMsg) {
        return this._toggleGenericError(this.selectors.emailContainer, this.selectors.emailError, isError, errorMsg);
    },

    _checkValidity() {
        const $pwdInput = this.$el.find(this.selectors.pwdInput);
        if (!Odigeo.Utils.isValidPassword($pwdInput.val(), true)) {
            this._togglePwdError(true, this.keys.signUp.pwdError);
            this.model.trackEvent('error');
            this.model.trackEvent('pwdError');
            return false;
        }
        return true;
    },

    _toggleGenericErrorMessage($container, $error, isError, errorMsg) {
        $container.toggleClass('invalid', isError);
        $error.text(errorMsg);
    },

    renderRegisterBtn(isWaiting) {
        this.$el.find(this.selectors.primeBtnContainer).empty();
        this.$el.find(this.selectors.primeBtnContainer).append(this.templates.registerBtn({
            keys: this.model.isRegistered() ? this.keys.signIn : this.keys.signUp,
            isWaiting,
        }));
    },

    renderTemplates(isPrimeFreeForAll, inputs) {
        const templates = {
            register: 'registerForm',
            travellers: isPrimeFreeForAll ? 'travellersBasicFree' : 'travellers',
            email: isPrimeFreeForAll ? 'emailPwdBasicFree' : 'emailPwd',
        };
        this.$el.find(this.selectors.formContainer).append(this.templates[`${templates.register}`]({
            keys: inputs.registered ? this.keys.signIn : this.keys.signUp,
            recaptchaEnabled: true,
            isWaiting: false,
        }));
        this.$el.find(this.selectors.primeTravellersContainer).append(this.templates[`${templates.travellers}`]({
            keys: inputs.registered ? this.keys.signIn : this.keys.signUp,
            traveller: inputs.traveller,
        }));
        this.$el.find(this.selectors.primeEmailContainer).append(this.templates[`${templates.email}`]({
            keys: inputs.registered ? this.keys.signIn : this.keys.signUp,
            pwd: !inputs.registered,
            email: inputs.email,
        }));
        this.renderRegisterBtn(false);
    },

    render() {
        this.$el.find(this.selectors.formContainer).empty();
        const registered = this.model.isRegistered() || false;
        const buyer = Odigeo._.get(this.model.get('bookingDetailDTO'), 'buyer') || {};
        const email = buyer.mail || '';
        const traveller = `${buyer.name} ${buyer.lastNames}`;
        if (this.model.isBasicFreeAccount()) {
            this._toggleLoadingRegister();
            return this.renderTemplates(true, {registered, traveller, email});
        } else if (this.model.get('userType') !== null && this.model.get('bookingDetailDTO') !== null) {
            Odigeo.Session.set('loginEmailPostbooking', email);
            this._toggleLoadingRegister();
            return this.renderTemplates(false, {registered, traveller, email});
        }
    },

    _toggleLoadingRegister() {
        this.$el.find(this.selectors.registerLoading).toggleClass('odf-hidden');
    },

}), processTemplateData);
